import React, { type ChangeEvent } from 'react';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import { type MessageDescriptor, useIntl } from '@atlassian/jira-intl';
import { SEARCH_TEXTFIELD_TEST_ID } from '../../constants';
import messages from './messages';

type Props = {
	onSearchTermChange: (e: ChangeEvent<HTMLInputElement>) => void;
	placeholder?: MessageDescriptor;
	isCompact?: boolean;
};

export const SearchBar = ({ onSearchTermChange, placeholder, isCompact }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Textfield
			testId={SEARCH_TEXTFIELD_TEST_ID}
			elemBeforeInput={
				<Box xcss={searchIconWrapperStyles}>
					<SearchIcon size="small" label="" />
				</Box>
			}
			placeholder={formatMessage(placeholder || messages.search)}
			onChange={onSearchTermChange}
			aria-label={formatMessage(placeholder || messages.search)}
			isCompact={isCompact}
		/>
	);
};

const searchIconWrapperStyles = xcss({
	marginLeft: 'space.100',
});
